import {Product} from '../../models/product.model';

type MarketplaceProductPurchaseKind =
    | 'subscription'
    | 'session'
    | 'seduta'
    | 'package'
    | 'consultation'
    | 'generic';

const normalizeMarketplaceProductText = (value?: string | null): string => {
    return value?.trim().toLowerCase().replace(/\s+/g, ' ') ?? '';
};

const includesMarketplaceKeyword = (value: string, keyword: string): boolean => {
    return value === keyword ||
        value.startsWith(`${keyword} `) ||
        value.endsWith(` ${keyword}`) ||
        value.includes(` ${keyword} `);
};

const getMarketplaceProductPurchaseKind = (product: Product): MarketplaceProductPurchaseKind => {
    if (product.family === 'Subscription') {
        return 'subscription';
    }

    const normalizedProductName = normalizeMarketplaceProductText(product.name);

    if (includesMarketplaceKeyword(normalizedProductName, 'seduta')) {
        return 'seduta';
    }

    if (includesMarketplaceKeyword(normalizedProductName, 'sessione')) {
        return 'session';
    }

    if (includesMarketplaceKeyword(normalizedProductName, 'consulenza')) {
        return 'consultation';
    }

    if (
        includesMarketplaceKeyword(normalizedProductName, 'percorso') ||
        includesMarketplaceKeyword(normalizedProductName, 'pacchetto') ||
        product.categories.length > 1
    ) {
        return 'package';
    }

    return 'generic';
};

export const getMarketplaceProductTypeLabel = (product: Product): string => {
    return product.family === 'Subscription' ? 'Abbonamento' : 'Acquisto singolo';
};

export const getMarketplaceProductCallToActionLabel = (product: Product): string => {
    switch (getMarketplaceProductPurchaseKind(product)) {
        case 'subscription':
            return 'Attiva abbonamento';
        case 'session':
            return 'Acquista sessione';
        case 'seduta':
            return 'Acquista seduta';
        case 'package':
            return 'Acquista pacchetto';
        case 'consultation':
            return 'Acquista consulenza';
        default:
            return 'Acquista';
    }
};
